import { Outlet } from "react-router";

export function ProjectReviewVisitV2ObservationsRoute() {
    return <Outlet />;
}
